import { create } from 'zustand';

/**
 * 服务不可用原因：unreachable=请求没到后端（网络不可达/超时/网关不可用），
 * degraded=请求到了但成片失败（后端异常）。文案不同，提示条据此换说法。
 */
export type NetDownReason = 'unreachable' | 'degraded' | null;

/**
 * 后端可达性（全局）：由 `request.ts` 的响应拦截器写入——传输层/网关层失败或成片失败置位，
 * 任一请求成功即复位。它只做**中断期的提示判据**：拦截器在「可用 → 不可用」跃变那一刻弹一条
 * Message，中断期间不再重复提示（一次刷新会并发十几个请求，后端不可用时它们会各自弹一条）。
 *
 * 没有任何组件订阅它来渲染页内元素——不可用提示一律走浮动 Message，
 * 页内横幅会占布局空间，出现与消失都会把内容整体推移。
 */
interface NetState {
  down: NetDownReason;
  setDown: (reason: NetDownReason) => void;
}

export const useNetStore = create<NetState>()((set) => ({
  down: null,
  setDown: (reason) => set({ down: reason }),
}));
